import client from './client';

// Members
export const getMembers      = (societyId)         => client.get(`/members/${societyId}`);
export const createMember    = (data)               => client.post('/members', data);
export const updateMember    = (id, data)           => client.put(`/members/${id}`, data);
export const deleteMember    = (id)                 => client.delete(`/members/${id}`);
export const getMemberLedger = (memberId)           => client.get(`/members/ledger/${memberId}`);

// Charge Heads
export const getChargeHeads   = (societyId)         => client.get(`/chargeheads/${societyId}`);
export const createChargeHead = (data)               => client.post('/chargeheads', data);
export const updateChargeHead = (id, data)           => client.put(`/chargeheads/${id}`, data);
export const deleteChargeHead = (id)                 => client.delete(`/chargeheads/${id}`);
export const seedChargeHeads  = (societyId)          => client.post(`/chargeheads/seed/${societyId}`);

// Bills
export const getBills         = (societyId, params)  => client.get(`/maintenance/bills/${societyId}`, { params });
export const getBill          = (billId)              => client.get(`/maintenance/bill/${billId}`);
export const generateBills    = (data)                => client.post('/maintenance/generate', data);
export const updateBill       = (billId, data)        => client.put(`/maintenance/bill/${billId}`, data);
export const deleteBill       = (billId)              => client.delete(`/maintenance/bill/${billId}`);

// Outstanding
export const getOutstanding   = (societyId)           => client.get(`/maintenance/outstanding/${societyId}`);

// Receipts
export const getReceipts      = (societyId)           => client.get(`/receipts/${societyId}`);
export const createReceipt    = (data)                => client.post('/receipts', data);
export const getReceiptDetail = (receiptId)           => client.get(`/receipts/detail/${receiptId}`);

// Billing Settings
export const getBillingSettings  = (societyId)        => client.get(`/society-settings/${societyId}/billing`);
export const saveBillingSettings = (societyId, data)  => client.put(`/society-settings/${societyId}/billing`, data);
export const getTerms            = (societyId)        => client.get(`/society-settings/${societyId}/terms`);
export const saveTerms           = (societyId, data)  => client.put(`/society-settings/${societyId}/terms`, { termsAndConditions: data });

// Member Charges
export const getMemberCharges        = (memberId)          => client.get(`/members/charges/${memberId}`);
export const saveMemberCharges       = (memberId, assignments) => client.put(`/members/charges/${memberId}`, { assignments });
export const bulkUploadMemberCharges = (societyId, rows)   => client.post(`/members/charges/bulk-upload/${societyId}`, { rows });
